module.exports = __webpack_public_path__ + "img/crm2banner.6cd7da61.png";